class TextAppear {
	constructor() {

		const items = document.querySelectorAll("[data-text-appear], .rich-text h1, .rich-text h2");
		items.forEach(elem => {
			const split = new SplitText(elem, {
				type: "lines",
				linesClass: "line"
			});

			ScrollTrigger.create({
				trigger: elem,
				start: "top bottom",
				once: true,
				onEnter: () => {
					if (!elem.appeared){
						elem.appeared = true;
						gsap.set(elem, {
							visibility: 'visible'
						});
						for (let i = 0; i < split.lines.length; i++) {
							gsap.from(split.lines[i], {
								yPercent: 20,
								opacity: 0,
								duration: 1,
								delay: i * 0.15,
								ease: "power4",
							});
						}
					}
				}
			});
		});
	}
}
